<template>
	<v-list-item v-if="item" link class="booker-location-single" :disabled="disabled" @click="sendAnalyticsData">
		<div class="booker-location-single__container">
			<div class="booker-location-single__data">
				<GlobalIcon class="booker-location-single__icon" :name="item?.icon" :height="20" />
				<div class="booker-location-single__title-opinion">
					<div v-if="title" class="booker-location-single__title">{{ title }}</div>
					<GlobalBookerOpinion :countRatings="item.countRatings" :ratings="item.ratings" :googleUrl="item.googleUrl" />
				</div>
			</div>
			<ButtonPrimary class="booker-location-single__button">{{ $t('common.select') }}</ButtonPrimary>
		</div>
	</v-list-item>
</template>

<script lang="ts" setup>
import { ELocationPurpose } from '~/data/bookerData'

const { locale } = useI18n()
const i18nService = usei18nService()

const prop = defineProps<{
	item: any
	disabled?: boolean
}>()

const title = computed(() => {
	if (!prop.item.city) return prop.item.name
	else if (prop.item.purpose === ELocationPurpose.MEET_AND_GREET)
		return `${i18nService.$tDynamic('data.cities', prop.item.city)}, ${locale.value === 'pl' ? prop.item.name : prop.item.nameEn}`
	else if ((prop.item.city && prop.item.icon === 'airplane') || (prop.item.city && prop.item.icon === 'train')) {
		return `${locale.value === 'pl' ? prop.item.name : prop.item.nameEn}`
	} else {
		return `${i18nService.$tDynamic('data.cities', prop.item.city)}, ${prop.item.address_street} ${prop.item.address_house_number ?? ''}`
	}
})

const sendAnalyticsData = () => {
	const gtmService = useGTMService()
	if (!gtmService) return
	const GTMParameters = {
		section: 'locations',
		element: 'location',
		element_value: prop.item.city
			?.toLowerCase()
			?.normalize('NFD')
			?.replace(/[\u0300-\u036F]/g, ''),
		location: prop.item.city
			?.toLowerCase()
			?.normalize('NFD')
			?.replace(/[\u0300-\u036F]/g, ''),
	}
	gtmService.offerInterest(GTMParameters)
}
</script>

<style lang="scss">
@import './Location';
</style>
